import { h, Fragment } from "preact";
import StockStatusTooltip from "./stock-message-tooltip";

export default function StockMessageContent({ message }) {
  return (
    <div
      className="stock-message"
      data-elevar-stock-message={message.elevarName}
    >
      <input
        type="hidden"
        name="properties[_stock_status]"
        value={message.attributeValue}
      />
      {message.lines.map(({ text, color }, i) => (
        <div
          key={text}
          className={`stock-message__message stock-message__message--line-${i + 1}`}
          style={{ color }}
        >
          <div
            className="rte--simple"
            dangerouslySetInnerHTML={{
              __html: text,
            }}
          ></div>
          {i === 0 && message.tooltip && (
            <StockStatusTooltip tooltip={message.tooltip} />
          )}
        </div>
      ))}
    </div>
  );
}
